import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Category.css";
import axios from "axios";
import { URL } from "../AxiosUrlGlobal";
import ReactLoading from "react-loading";
import { motion } from "framer-motion";
import { CategorySlider } from "../Slider/Slider";

function Category() {
  const [category, setCategory] = useState([]);
  const [nocategory, setNocategory] = useState(false);
  const [loadCategory, setLoadCategory] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL}/e-category`)
      .then((res) => {
        setCategory(res.data);
        setLoadCategory(false);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (category.length === 0 && !loadCategory) {
      setNocategory(true);
    }
  }, [loadCategory]);

  return (
    <>
      {loadCategory && (
        <div className="category-loading">
          <div className="category-loading-in">
            <ReactLoading type={"spin"} color={"#333"} height={50} width={50} />
          </div>
        </div>
      )}

      {nocategory && <div className="no-category">No Category Found..</div>}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2 }}
        className="category-main"
      >
        <CategorySlider category={category} />
      </motion.div>
    </>
  );
}

export default Category;
